import _ from "lodash";
import Swiper from 'swiper';
import BaseControl from "scripts/base-control";
import { Cards } from "./hero.models";
import heroCard from "./hero-card.stache";
import heroTwoCard from "./hero-two-cards.stache";
import heroRow from "./hero-other-cards.stache";
import heroRowWithSwiper from "./hero-other-cards-swiper.stache";

export const HeroModule = BaseControl.extend({
    init() {
        this._super();

        this.$heroContainer = this.$element.find(".m-hero-container");
        this.cards = new Cards(this.options.cards);

        this.renderHeroLayout();
    },

    initSwiper(swiperData) {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }

        const bottomLayoutWithSwiper = heroRowWithSwiper(swiperData);
        this.$heroContainer.append(bottomLayoutWithSwiper);
        this.$swiperContainer = this.$heroContainer.find(".swiper-container");

        this.swiper = new Swiper(this.$swiperContainer, {
            slidesPerView: 3,
            spaceBetween: 20,
            draggable: false,
            simulateTouch: false,
            speed: 500,
            createElements: true,
            navigation: {
                prevEl: this.$heroContainer.find(".button-prev"),
                nextEl: this.$heroContainer.find(".button-next"),
            },
        });
    },

    renderHeroLayout() {
        const heroLayout = this.getHeroLayout();

        if (heroLayout.top) {
            const topLayout = this.buildLayout(heroLayout.top);
            this.$heroContainer.append(topLayout);
        }

        if (heroLayout.bottom) {
            const bottomLayout = this.buildLayout(heroLayout.bottom);
            this.$heroContainer.append(bottomLayout);

            if (heroLayout.bottom.data.cards.length > 3) {
                this.initSwiper(heroLayout.bottom.data);
            }
        }
    },

    getHeroLayout() {
        if (!this.cards.length) {
            console.error("[HeroModule]: No cards provided");
            return ({top: null, bottom: null});
        }

        const isTwoCardsTemplate = this.cards.length === 2;
        const topLayoutCards = isTwoCardsTemplate ? this.cards : this.cards.slice(0, 1);
        const bottomLayoutCards = this.cards.slice(1);

        return ({
            top: {
                template: isTwoCardsTemplate ? heroTwoCard : heroCard,
                data: {
                    cards: topLayoutCards.map(this.buildHeroCard)
                }
            },
            bottom: bottomLayoutCards.length ? {
                template: heroRow,
                data: {
                    cards: bottomLayoutCards.map(this.buildHeroCard),
                    visibility: isTwoCardsTemplate ? "small" : "all",
                    heroRowClass: bottomLayoutCards.length > 3 ? "" : "m-hero-row--no-swiper"
                }
            } : null
        });
    },

    buildLayout(layout) {
        return layout.template(layout.data);
    },

    buildHeroCard(card) {
        return {
            text: card.text,
            isVideoCard: card.mediaType === "video",
            url: card.url,
            target: card.target === "new" ? "_blank" : "_self",
            action: card.action,
            title: card.title,
            subtitle: card.subtitle,
            caption: card.paginationLabel,
            image: card.image
        };
    }
});
